import { useEffect } from 'react';
import RecruitMinisterPost from '../../screens/recruit/recruit_minister/RecruitMinisterPost';
import RecruitOverseasPost from '../../screens/recruit/recruit_overseas/RecruitOverseasPost';
import RecruitSimplePost from '../../screens/recruit/common/RecruitSimplePost';
import type { RecruitBoardConfig } from '../../screens/recruit/common/RecruitTypes';
import type { RecruitSavedEditType } from './recruitSavedAdminShared';
import '../../screens/recruit/common/Recruit.scss';
import '../../screens/recruit/common/RecruitList.scss';

type Props = {
  recruitType: RecruitSavedEditType;
  apiBase: string;
  config?: RecruitBoardConfig;
  itemId: number | string;
  userAccount?: string;
  onClose: () => void;
  onSaved: () => void;
};

export default function RecruitSavedEditModal({
  recruitType,
  config,
  itemId,
  onClose,
  onSaved,
}: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="admin-board-manage__modal-backdrop" onClick={onClose}>
      <div
        className="admin-board-manage__modal admin-board-manage__modal--wide admin-board-manage__modal--recruit-edit"
        role="dialog"
        aria-modal="true"
        aria-labelledby="recruit-edit-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-board-manage__modal-head">
          <h3 id="recruit-edit-modal-title">구인 공고 수정</h3>
          <button
            type="button"
            className="admin-board-manage__modal-close"
            onClick={onClose}
            aria-label="닫기"
          >
            ×
          </button>
        </div>

        <div className="admin-board-manage__modal-body admin-board-manage__modal-body--recruit-form">
          {recruitType === 'minister' ? (
            <RecruitMinisterPost
              adminEditId={itemId}
              embeddedInModal
              onAdminSaved={onSaved}
              onAdminCancel={onClose}
            />
          ) : recruitType === 'overseas' ? (
            <RecruitOverseasPost
              adminEditId={itemId}
              embeddedInModal
              onAdminSaved={onSaved}
              onAdminCancel={onClose}
            />
          ) : config ? (
            <RecruitSimplePost
              config={config}
              adminEditId={itemId}
              embeddedInModal
              onAdminSaved={onSaved}
              onAdminCancel={onClose}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}
